const Utils = (function(){
  const checkLocalStorageAvailability = () => {
    const randomString = `test-${Math.round(Math.random() * 10000)}`;
    try {
      localStorage.setItem(randomString, randomString);
      localStorage.removeItem(randomString);
      return true;
    } catch(e) {
      return false;
    }
  }
  const isLocalStorageAvailableResult = checkLocalStorageAvailability();

  return {
    device: {
      isIOS: () => (/iPad|iPhone|iPod/).test(navigator.userAgent) && !window.MSStream,
      isAndroid: () => (/Android/i).test(navigator.userAgent),
      isMobile: () => Utils.device.isIOS() || Utils.device.isAndroid(),
      isLocalStorageAvailable: () => isLocalStorageAvailableResult
    }
  }
}());

function showAppAdvocacyOverlay() {
  if (!Utils.device.isLocalStorageAvailable()) {
    return false;
  }

  const isConsentedForAppAdvocacy = document.body.contains(
    document.querySelector('.app-advocacy-banner')
  );

  const alreadySeen = localStorage.getItem('app-advocacy-overlay-seen');
  if (alreadySeen || !isConsentedForAppAdvocacy) {
    return;
  }

  // on close clicked
  const handleClose = () => {
    localStorage.setItem('app-advocacy-overlay-seen', true);
    $('.app-advocacy-banner').slideUp();
  }

  $('.app-advocacy-banner button.close').click(() => {
      trackPageEvent({ category: 'app-link-overlay', action: 'click', label: 'close-download-app-link' })
      handleClose();
  });

  // on download clicked
  $('.app-advocacy-banner .download-container a.download').each((_, node) => {
    $(node).on('click', () => {
      trackPageEvent({ category: 'app-link-overlay', action: 'click', label: 'download-app-link' })
      handleClose();
    });
  });

  $('.app-advocacy-banner').removeClass('hidden');
  trackPageEvent({ category: 'app-link-overlay', action: 'view', label: 'download-app-link' });
};

function manageAppAdvocacyBadges() {
  const addTracking = () => {
    $('footer .app-store-links a').each((i, node) => {
      $(node).on('click', () =>
        trackPageEvent({ category: 'app-link-footer', action: 'click', label: 'download-app-link' })
      )
    })
  }

  if (Utils.device.isMobile()) {
    if (Utils.device.isIOS()) {
      $('.js-google-play-link').remove();
    } else if (Utils.device.isAndroid()) {
      $('.js-app-store-link').remove();
    }

    $('.js-app-store-link, .js-google-play-link').show();
  }

  addTracking();
}

const trackPageEvent = ({ category, action, property, label, value }) => snowplow(
  'trackStructEvent',
  category,
  action,
  label,
  property,
  value
);

const PORTFOLIO_IMAGE_CLASS = '.js-employee-portfolio-image';
const BOOKING_BUTTON_CLASS = '.widget-button';
const PHONE_TRACK_CLASS = '.js-track-phone';
const EMAIL_TRACK_CLASS = '.js-track-email';

$(document).ready(function() {

  $(`.site-nav ${BOOKING_BUTTON_CLASS}`).on('click', function(e) {
    trackPageEvent({ category: 'book-now', action: 'click' });
  });

  $(`.price-book ${BOOKING_BUTTON_CLASS}`).on('click', function(e) {
    trackPageEvent({ category: 'book', action: 'click', label: 'price-list' });
  });

  $(BOOKING_BUTTON_CLASS).on('click', function(e) {
    if ($(this).attr('data-popup') !== undefined && $(this).attr('data-popup') !== false) {
      e.preventDefault();
      window.open($(this).attr('href'), "",
      "width=640,height=640,resizable=0,scrollbars=yes,menubar=0,status=0,directories=0,toolbar=0,location=0");
    }
  })

  $('.gallery-image a').magnificPopup({
    type: 'image',
    gallery: {
      enabled: true,
      navigateByImgClick: true,
      tCounter: ''
    }
  });
  $(PORTFOLIO_IMAGE_CLASS).on('click', function(e) {
    trackPageEvent({ category: 'portfolio-photo', action: 'click' });
  });

  const portfolioIds = document.querySelectorAll('[class*=js-portfolio]');
  portfolioIds.forEach(function(item, i){
    $(item).find(PORTFOLIO_IMAGE_CLASS).magnificPopup({
      type: 'image',
      gallery: {
        enabled: true,
        tCounter: '',
        titleSrc: 'title'
      }
    });
  });

  $('.mobile-menu-toggle').on('click', function(e) {
    $('.mobile-wrap, .mobile-menu-toggle').toggleClass('open');
    e.preventDefault();
  })

  if (window.location.pathname === '/' && window.location.hash !== '#contact') {
    $('.js-menu-contact').on('click', function(e) {
      const venueId = e.currentTarget.dataset.id;
      snowplow('trackPageView', null, [{
        schema: "iglu:com.treatwell/venue/jsonschema/1-0-0",
        data: { venue_id: venueId, viewName: 'contact' }
      }]);
    });
  }

  $(PHONE_TRACK_CLASS).on('click', function(e) {
    trackPageEvent({ category: 'contact', action: 'click', label: 'phone'});
  });

  $(EMAIL_TRACK_CLASS).on('click', function(e) {
    trackPageEvent({ category: 'contact', action: 'click', label: 'email'});
  });

  manageAppAdvocacyBadges();
  initConsentMap();

  if (Utils.device.isMobile()) {
    showAppAdvocacyOverlay();
  }
})
